import { icon } from "leaflet";

const useStyles = (theme) => ({
  mainContent: {
    flexDirection: { xs: "column", md: "row" },
    gap: 2,
    width: { xs: "300px", md: "450px" },
    minWidth: "250px",
    maxWidth: "100%",
  },

  cardImg: {
    bgcolor: theme?.palette?.mode === "dark" ? "#262626" : "#f9fafb",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  cardAction: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "150px",
    width: "200px",
    gap: "10px",
  },
  icon: {
    fontSize: "48px",
  },
  boxAddIcon: {
    position: "relative",
    display: "flex",
  },
  addIcon: {
    position: "absolute",
    color: "white",
    backgroundColor: "primary.main",
    borderRadius: "100%",
    right: 0,
    bottom: 0,
    border: `2px solid ${theme.palette.mode === "dark" ? "#1E1E1E" : "#fff"}`,
    fontSize: "22px",
  },
  typography: {
    fontWeight: 500,
    width: { xs: "100%", md: "160px" },
    textAlign: "center",
  },
  textfield: {
    maxWidth: "100%",
    mb: "10px",
    "& .MuiOutlinedInput-root": {
      backgroundColor: theme.palette.background.paperLinkedMaps,
      boxShadow: "none",

      "&:hover": {
        backgroundColor: theme.palette.background.paperLinkedMaps,
      },
    },
  },
  formControl: { gap: "8px", mt: "8px" },
  confirmButton: {
    color: theme?.palette?.color?.buttonConfirm || "primary.main",
  },
  dialogContent: {
    width: { xs: "300px", md: "400px" },
    minWidth: "250px",
    maxWidth: "100%",
  },
});

export default useStyles;
